
// Mirrors server/middleware/auth.ts for client-side navigation; the server check is the one that counts.
export default defineNuxtRouteMiddleware((to) => {
    const required_role = getRequiredRole(to.path, 'GET')
    if (required_role === 'public') return

    const userStore = useUserStore()
    if (!userStore.isLoggedIn()) return navigateTo(loginPathFor(to.fullPath))
    if (!required_role || !userStore.permissions.includes(required_role)) return navigateTo('/no-access')
})
